/**
 * @generated SignedSource<<63053e0de0de503b8795acbe2618dc91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
export type CemeteryMarkerQuery$variables = {
  id: number
}
export type CemeteryMarkerQuery$data = {
  readonly item: {
    readonly cemeteryId: number
    readonly name: string
    readonly section_types: ReadonlyArray<{
      readonly name: string
    }>
    readonly cemetery_types: ReadonlyArray<{
      readonly name: string
      readonly code: string
    }>
    readonly sects: ReadonlyArray<{
      readonly name: string
    }>
    readonly review_summary: {
      readonly count: number
      readonly total_score: number | null
    }
    readonly main_image: {
      readonly alt: string | null
      readonly path: string | null
    } | null
    readonly best_price_by_category: {
      readonly normal: {
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_code: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
      readonly nokotsu: {
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_code: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
      readonly jumoku: {
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_code: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
      readonly eitai_kuyo: {
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_code: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
    }
  } | null
}
export type CemeteryMarkerQuery = {
  variables: CemeteryMarkerQuery$variables
  response: CemeteryMarkerQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id'
      }
    ],
    v1 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null
    },
    v2 = [v1 /*: any*/],
    v3 = [
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price1',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price1_unit',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price2',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price2_unit',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'purchase_price',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'purchase_price_unit',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'calculated_purchase_price',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'category_code',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'purchase_price_option',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price3',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'simulated_price3',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price4',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price4_name',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'lot_area',
        storageKey: null
      }
    ],
    v4 = [
      {
        alias: 'item',
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id'
          }
        ],
        concreteType: 'Cemetery',
        kind: 'LinkedField',
        name: 'getCemetery',
        plural: false,
        selections: [
          {
            alias: 'cemeteryId',
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null
          },
          v1 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'section_types',
            plural: true,
            selections: v2 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'cemetery_types',
            plural: true,
            selections: [
              v1 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'code',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'sects',
            plural: true,
            selections: v2 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryReviewSummary',
            kind: 'LinkedField',
            name: 'review_summary',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'count',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'total_score',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryImage',
            kind: 'LinkedField',
            name: 'main_image',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'alt',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'path',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryBestPriceByCategory',
            kind: 'LinkedField',
            name: 'best_price_by_category',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'normal',
                plural: false,
                selections: v3 /*: any*/,
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'nokotsu',
                plural: false,
                selections: v3 /*: any*/,
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'jumoku',
                plural: false,
                selections: v3 /*: any*/,
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'eitai_kuyo',
                plural: false,
                selections: v3 /*: any*/,
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'CemeteryMarkerQuery',
      selections: v4 /*: any*/,
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'CemeteryMarkerQuery',
      selections: v4 /*: any*/
    },
    params: {
      cacheID: 'e2fddefbd408916a515a2ef7c136fcc6',
      id: null,
      metadata: {},
      name: 'CemeteryMarkerQuery',
      operationKind: 'query',
      text: 'query CemeteryMarkerQuery(\n  $id: Int!\n) {\n  item: getCemetery(id: $id) {\n    cemeteryId: id\n    name\n    section_types {\n      name\n    }\n    cemetery_types {\n      name\n      code\n    }\n    sects {\n      name\n    }\n    review_summary {\n      count\n      total_score\n    }\n    main_image {\n      alt\n      path\n    }\n    best_price_by_category {\n      normal {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      nokotsu {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      jumoku {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      eitai_kuyo {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = '85e4760d4cff4bb5835fba0175bb93f5'

export default node
